import React from "react";
import "./SendTestInvitation.css";
import SendTestIcon from "../../../../assets/candidate-profile/sendTestiInvitation.svg";

const SendTestInvitation = ({ onClick }) => {
  return (
    <button
      id="sendTestInvitation"
      className="send-test-invitation-frame"
      onClick={onClick}
    >
      <img src={SendTestIcon} alt="Send Test" className="send-test-invitation-icon-mobile" />
      <div className="send-test-invitation-text-wrapper">
        Send Test Invitation
      </div>
    </button>
  );
};

export default SendTestInvitation;
